/**
 * Avis Google My Business RÉELS de KS Rent Services — source de vérité unique.
 *
 * Importés depuis la fiche GMB (place_id ChIJZyLnm7zUmikR6qmaUYKKEno) le
 * 2026-06-29 : 38 avis, note moyenne 5,0/5 (38 × 5★). Texte verbatim — NE PAS
 * éditer/corriger (authenticité). Ces avis sont publics sur Google.
 *
 * Affichage on-page = OK (preuve sociale + E-E-A-T + AEO). On NE génère PAS de
 * schema `Review`/`AggregateRating` par avis (la note de l'entité sur son propre
 * site = "self-serving", ignorée par Google depuis 2019). La note globale reste
 * portée uniquement par le nœud LocalBusiness via app/config/reputation.ts.
 */

export type GoogleReview = {
  /** Identifiant interne Localnord (traçabilité). */
  id: string;
  /** Nom public de l'auteur tel qu'affiché sur Google. */
  author: string;
  /** Note (toujours 5 ici). */
  rating: number;
  /** Texte verbatim de l'avis ("" si avis sans commentaire). */
  text: string;
  /** Langue détectée (fr/en/null). */
  lang: "fr" | "en" | "other" | null;
  /** Date de publication (YYYY-MM-DD). */
  date: string;
  /** Mis en avant dans la section témoignages on-page. */
  featured?: boolean;
};

/** Référence GMB publique (note + volume vérifiables sur Google). */
export const GMB = {
  ratingValue: 5,
  reviewCount: 38,
  placeId: "ChIJZyLnm7zUmikR6qmaUYKKEno",
  /** Lien public d'avis Google (place_id). */
  reviewsUrl:
    "https://search.google.com/local/reviews?placeid=ChIJZyLnm7zUmikR6qmaUYKKEno",
} as const;

/** Les 38 avis Google verbatim (du plus récent au plus ancien). */
export const GOOGLE_REVIEWS: GoogleReview[] = [
  {
    id: "171a6f6a",
    author: "Alex Leguen",
    rating: 5,
    text: "Excellent service great team",
    lang: "en",
    date: "2026-06-24",
  },
  {
    id: "53c290ca",
    author: "Nicolas Sergueev",
    rating: 5,
    text: "Excellente expérience ! Chauffeur très professionnel, ponctuel et sympathique. Véhicule propre et confortable. Service sérieux et de grande qualité. Je recommande sans hésitation et je referai appel à KS Rent Services avec plaisir. Merci !",
    lang: "fr",
    date: "2026-06-22",
    featured: true,
  },
  {
    id: "144111fd",
    author: "irfaan oumerhatttab",
    rating: 5,
    text: "Service incroyable avec KS Rent Services durant le Lions 2026 à Cannes.\n\nChauffeur très professionnel, ponctuel, sérieux et disponible. Le véhicule était propre, confortable et le service a été à la hauteur du début à la fin. Une vraie tranquillité d’esprit pour les déplacements.\n\nJe recommande fortement KS Rent Services pour toute personne qui cherche un service VTC ou une location de voiture fiable à Cannes.",
    lang: "fr",
    date: "2026-06-22",
    featured: true,
  },
  {
    id: "dafbd462",
    author: "Mustapha Chihi",
    rating: 5,
    text: "Rien à dire de part leurs qualités et leurs compétences, j’ai loué une voiture pour 4 jour je l’ai prolongé sans problème ni difficulté\n\nje vous conseille vous pouvez y aller les yeux fermés !!!",
    lang: "fr",
    date: "2026-05-28",
    featured: true,
  },
  {
    id: "cb34d5d4",
    author: "Edgar Mkhitaryan",
    rating: 5,
    text: "Excellent société, accueillent agréable",
    lang: "fr",
    date: "2026-03-24",
  },
  {
    id: "032ac856",
    author: "Էդուարդ Մխիթարյան",
    rating: 5,
    text: "Спасибо за хороший сервис,добросовестное отношение,пунктуальность и человеческие цены.Браво !",
    lang: "other",
    date: "2026-03-04",
  },
  {
    id: "920255a6",
    author: "Restaurant Farooj",
    rating: 5,
    text: "merci pour le services chauffeur accompagnement parfait",
    lang: "fr",
    date: "2026-02-27",
  },
  {
    id: "0228da4d",
    author: "Taya - France Tourisme Co",
    rating: 5,
    text: "nous avons fait appel a ks rent services pour une de leur excursion service profesionelle chauffeur ayant une tres bonne conaissance de la region je recommande",
    lang: "fr",
    date: "2026-02-27",
    featured: true,
  },
  {
    id: "7d380b4f",
    author: "Carlux Rent",
    rating: 5,
    text: "collaborateur toujours au top merci pour la livraison",
    lang: "fr",
    date: "2026-02-27",
  },
  {
    id: "cc483f8c",
    author: "Altaya M",
    rating: 5,
    text: "merci pour le services",
    lang: "fr",
    date: "2026-02-27",
  },
  {
    id: "cfb00c5d",
    author: "Midnight Shop",
    rating: 5,
    text: "Service au top ! J’ai pris un transfert aéroport vers Cannes en van : ponctuel, confortable et chauffeur très professionnel. Je recommande sans hésiter !",
    lang: "fr",
    date: "2026-02-27",
    featured: true,
  },
  {
    id: "d87a3a76",
    author: "Aymen Tajouri",
    rating: 5,
    text: "Très bonne expérience avec KS Rent Service. L’équipe est sérieuse, professionnelle et très accueillante, toujours à l’écoute pour répondre aux besoins. Le service est rapide, les véhicules sont propres, récents et parfaitement entretenus, avec des tarifs clairs et honnêtes. Je recommande vivement KS Rent Service pour leur fiabilité et la qualité de leur service.",
    lang: "fr",
    date: "2026-02-27",
    featured: true,
  },
  {
    id: "0fad59a9",
    author: "Yazid Taya",
    rating: 5,
    text: "Service impeccable du début à la fin. Chauffeur ponctuel, très professionnel et véhicule irréprochable. Trajet confortable et agréable. Je recommande KS Rent Services les yeux fermés !",
    lang: "fr",
    date: "2026-02-27",
    featured: true,
  },
  {
    id: "267877a8",
    author: "Matteo",
    rating: 5,
    text: "Service absolument exceptionnel du début à la fin ! Sofiane est un véritable professionnel : ponctuel, élégant, discret et toujours à l’écoute. J’ai eu recours à ses services de chauffeur et de conciergerie à Cannes, et tout a été parfait. Que ce soit pour un transfert, une mise à disposition ou une demande spécifique, il trouve toujours une solution rapide, avec le sourire et une grande classe.\n\nSon véhicule est irréprochable, d’un confort incroyable, et il vous fait sentir comme une vraie star ! On sent l’amour du métier et le souci du détail. Je recommande à 1000 % pour tous ceux qui cherchent un service haut de gamme et fiable sur la Côte d’Azur.\n\nMerci encore Sofiane pour cette expérience inoubliable !",
    lang: "fr",
    date: "2025-05-19",
    featured: true,
  },
  {
    id: "387b74ca",
    author: "zakavikivekeu",
    rating: 5,
    text: "Accueil patient très chaleureux ! Et qualité et fiabilité bel et bien au rendez-vous ✅ Je recommande vivement cette agence.",
    lang: "fr",
    date: "2025-03-27",
  },
  {
    id: "ed1f45d0",
    author: "John Johansson",
    rating: 5,
    text: "Meilleur service de chauffeur à cannes.\nJ’avais un besoin urgent de chauffeur pour un client pour le mipim, ks rent services a parfaitement su répondre aux exigences de notre client et aussi à l’excellence attendu pour ce genre d’événements très privé, nous ferrons définitivement appel à leur services pour tout nos clients se rendants sur la Côte d’Azur dorénavant.",
    lang: "fr",
    date: "2024-08-02",
    featured: true,
  },
  {
    id: "43135d3a",
    author: "Lilou Charles",
    rating: 5,
    text: "J'ai fait appel à leur services de chauffeur privé pour l'événement du mipim. Courtois et professionnels merci KS.",
    lang: "fr",
    date: "2024-07-30",
  },
  {
    id: "aeaad628",
    author: "Hassine Bacem",
    rating: 5,
    text: "Ayant récemment utilisé les services de Ks Rent Services pour la location d'un véhicule, mon expérience a été très positive. Le processus de réservation en ligne était simple et efficace, le personnel était courtois et professionnel lors de la prise en charge du véhicule, et le véhicule lui-même était en parfait état et correspondait à mes attentes.",
    lang: "fr",
    date: "2024-07-29",
    featured: true,
  },
  {
    id: "e22765c3",
    author: "Clémence-alice Froidurot",
    rating: 5,
    text: "Meilleur service de chauffeurs privés à Cannes !\nJe recommande vivement.",
    lang: "fr",
    date: "2024-07-18",
  },
  {
    id: "a01306bf",
    author: "Ryan",
    rating: 5,
    text: "Very professional company located in Cannes city centre. Thank you for going above and beyond during my stay in Cannes !!",
    lang: "en",
    date: "2024-07-01",
    featured: true,
  },
  {
    id: "70edfd97",
    author: "Tristan Malone",
    rating: 5,
    text: "Service au top merci à Lucas pour son professionnalisme et sa politesse je conseille\nService de chauffeur privée à cannes au top\nMerci KS",
    lang: "fr",
    date: "2024-06-30",
  },
  {
    id: "23ea899a",
    author: "adam bettan",
    rating: 5,
    text: "Chauffeur privée au top ,trajet agréable",
    lang: "fr",
    date: "2024-06-29",
  },
  {
    id: "8e1df2fa",
    author: "Swan Garcia",
    rating: 5,
    text: "service de très bonne qualité chauffeurs très aimables et courtois je conseille fortement",
    lang: "fr",
    date: "2024-06-29",
  },
  {
    id: "d23517f0",
    author: "Alex",
    rating: 5,
    text: "Expérience magnifique avec KS, chauffeur privé très pro. Je suis resté une semaine avec eux sur cannes et monaco c’était parfait 🙏🏼",
    lang: "fr",
    date: "2024-06-29",
    featured: true,
  },
  {
    id: "9ef5dc56",
    author: "Jacem",
    rating: 5,
    text: "Très bon séjours à cannes avec leurs participation, merci pour le transfert et la location du véhicule. Je recommande",
    lang: "fr",
    date: "2024-06-27",
  },
  {
    id: "75e334a3",
    author: "Noam Grenet",
    rating: 5,
    text: "J’ai eu une très bonne expériences lors de mon séjour à Cannes merci à toute l’équipe ks rent",
    lang: "fr",
    date: "2024-06-22",
  },
  {
    id: "fcbf0290",
    author: "Lisa Lagrain",
    rating: 5,
    text: "Un service de qualité, merci beaucoup pour votre professionnalisme !",
    lang: "fr",
    date: "2024-06-18",
  },
  {
    id: "279b6889",
    author: "stephanie BARGE",
    rating: 5,
    text: "Mon expérience sur Cannes en VTC m'a conquise : découverte de cette ville emblématique et de ses joyaux cachés. Merci à Lucas et toute son équipe. Professionnalisme, discrétion et service premium étaient au rendez-vous. Je recommande vivement.",
    lang: "fr",
    date: "2024-06-14",
    featured: true,
  },
  {
    id: "1d9511c1",
    author: "Ferrandis Kevin",
    rating: 5,
    text: "Au top!\nLe chauffeur était aimable souriant la voiture était dans un état irréprochable c’était très pro !\nRien à dire, c’était très professionnel !\nJe recommande vivement !",
    lang: "fr",
    date: "2024-06-06",
  },
  {
    id: "f9f494e8",
    author: "Z K",
    rating: 5,
    text: "i rented a car here, it was perfect with great a great service. will definitely rent from there again",
    lang: "en",
    date: "2024-05-14",
    featured: true,
  },
  {
    id: "7a665a81",
    author: "Enzo",
    rating: 5,
    text: "Les numéros 1 service au top 👍🏻",
    lang: "fr",
    date: "2024-05-13",
  },
  {
    id: "bbf2aa98",
    author: "karine donato",
    rating: 5,
    text: "Chauffeurs sympathiques et très professionnels . Je recommande cette société .",
    lang: "fr",
    date: "2024-05-13",
  },
  {
    id: "b47709aa",
    author: "Ahmed Rf",
    rating: 5,
    text: "Très bonne expérience",
    lang: "fr",
    date: "2024-05-13",
  },
  {
    id: "82c3871d",
    author: "Oscar Chanay Cortijos",
    rating: 5,
    text: "Excellent service. Je recommande",
    lang: "fr",
    date: "2023-08-01",
  },
  {
    id: "c6c7a46a",
    author: "Catherine Turner",
    rating: 5,
    text: "Prestataire vraiment excellent !\nVoitures magnifiques et propres, parfaitement entretenues. Nous avons été parfaitement accueillis. Nous nous sommes sentis comme des princesses et princes à bord, en sa compagnie agréable.\nSes tarifs sont très biens, et bien moins chères que d'autres, notamment pour les kilomètres supplémentaires hors du forfait initial, ce qui était parfait pour noUS.\nMerci beaucoup encore pour ce moment magique.\nJe recommande à 400%!",
    lang: "fr",
    date: "2023-07-13",
    featured: true,
  },
  {
    id: "4e425e5e",
    author: "Cannelle Gouffran",
    rating: 5,
    text: "",
    lang: null,
    date: "2023-07-10",
  },
  {
    id: "9bdd063c",
    author: "Kilian Ackenine",
    rating: 5,
    text: "",
    lang: null,
    date: "2023-07-10",
  },
  {
    id: "73364f70",
    author: "Mathieu Maclos",
    rating: 5,
    text: "Service haut de gamme,\nJe suis arriver ce matin à l’aéroport de Nice en urgence, ils ont mis à ma disposition un chauffeur dans les plus bref délai. Du haut standing !",
    lang: "fr",
    date: "2023-06-13",
    featured: true,
  },
];

/** Avis avec texte (exclut les avis note-seule). */
export const GOOGLE_REVIEWS_WITH_TEXT = GOOGLE_REVIEWS.filter(
  (r) => r.text.trim().length > 0,
);

/** Sélection mise en avant pour la section témoignages on-page. */
export const FEATURED_REVIEWS = GOOGLE_REVIEWS.filter((r) => r.featured);
